
import * as type from '../../types/inventoryGroups'

const reducer = (state = [], action) => {
    switch (action.type) {
        case type.FETCH_INVENTORY_GROUP:
            return action.payload
        default:
            return state
    }
}

export default reducer